import store from '../redux/store';

import * as CannedData from './constants/CannedData';
import * as Security from '../utils/auth/Security';
import * as Consts from './constants/Consts';
import { ClientType } from "./constants/Consts";
import { DispatchAF } from './AFStoreDispatchAction';
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';


export const getContextClientId = () => {
    const reduxStore = store.getState();

    var contextClientId = null;
    if(Security.isSystemUser()) {
        if(!reduxStore.bucket.bucket.userContext?.clientId) {
            if(reduxStore.clients.status === ReduxDataStatus.SUCCEEDED && 
                reduxStore.clients.clients.length > 0) {

                contextClientId = reduxStore.clients.clients[0].id;
                DispatchAF.setBucketValue({userContext: {clientId: contextClientId}});
                DispatchAF.fetchSubcontracted(contextClientId);
            }
        }
        else {
            contextClientId = reduxStore.bucket.bucket.userContext.clientId;
        }
    }
    else {
        contextClientId = reduxStore.auth.afUser.generalSection.clientId;
    }

    return contextClientId;
}


export const getContextClient = () => {
    const reduxStore = store.getState();

    var contextClient = null;

    const contextClientId = getContextClientId();

    if(contextClientId != null ) {
        if(contextClientId === Consts.COREVO_CLIENT_ID) {
            contextClient = CannedData.CorevoClient;
        }
        else{
            contextClient = reduxStore.clients.clients.find((client) => client.id === contextClientId);
        }
    }

    return contextClient;
}     


export const getSiuClient = () => {
    const reduxStore = store.getState();

    var siuClient = null;

    if(Security.isSystemUser()) {
        siuClient = CannedData.CorevoClient;
    }
    else {
        const siuClientId = reduxStore.auth.afUser.generalSection.clientId;
        siuClient = reduxStore.clients.clients.find((client) => client.id === siuClientId);
    }

    return siuClient;
}


export const getClientType = (clientId) => {
    const reduxStore = store.getState();

    var clientType = null;
    const client = reduxStore.clients.clients.find((client) => client.id === clientId);

    if(client) {
        clientType = client.generalSection.clientType;
    }

    return clientType;
}



/*
 * For a Client ID - with the expectation that the client is an Employer and not a Service Provider
 * Return the Employer ID
 */
export const getClientEmployerEID = (clientId) => {
    const reduxStore = store.getState();

    const myClient = reduxStore.clients.clients.find((client) => client.id === clientId);
    const myEmployerId = myClient.generalSection.myEmployerId;

    return myEmployerId;
}


/*
 * For the Signed In User - with the expectation that the client is an Employer and not a Service Provider
 * Return the Employer ID
 */
export const getSiuClientEmployerEID = () => {
    const reduxStore = store.getState();

    const myClientId = reduxStore.auth.afUser.generalSection.clientId;
    const myClient = reduxStore.clients.clients.find((client) => client.id === myClientId);
    const myEmployerId = myClient.generalSection.myEmployerId;

    return myEmployerId;
}



/*
 * For the Signed In User - with the expectation that the client is an Employer and not a Service Provider
 * Return the RSVTI Service Provider ID
 */
export const getSiuClientEmployerRsvtiServiceProvider = () => {
    const reduxStore = store.getState();

    const myClientId = reduxStore.auth.afUser.generalSection.clientId;
    const myClient = reduxStore.clients.clients.find((client) => client.id === myClientId);
    const externalProviderId = myClient.generalSection.rsvtiServiceByClientId;

    return externalProviderId;
}
